<template>
  <div>
    <div class="bg-transmaes-green flex justify-between px-3">
      <img class="w-40" src="../assets/images/transmaes_logo_big.svg" alt="">
      <a @click="logout" class="flex">
        <img class="mr-2 w-10" src="../assets/images/log_off_btn.svg" alt="">
      </a>
    </div>
    <div class="grid grid-cols-12 flex flex-1">
      <div class="col-span-8 bg-gray-100 flex flex-col h-full">
        <main class="p-16 flex-1">
          <p class="text-3xl font-bold">{{moment().format("DD MMMM YYYY")}}</p>
          <div class="my-10">
            <p class="text-transmaes-green text-xl capitalize">{{greeting}}</p>
            <p class="text-lg">{{$t('home_greeting_message')}}</p>
          </div>
          <div class="flex flex-row" v-for="entry in activeRide.entries" :key="entry.id">
            <div class="h-16 w-16 bg-gray-200 flex justify-center items-center"
                 :class="{ 'rounded-t-full': entry.id ===  activeRide.entries[0].id }">
              <div class="rounded-full h-5 w-5"
                   :class="{ 'bg-transmaes-green': entry.status === Statusses.START,
                             'bg-transmaes-yellow': entry.status === Statusses.PAUSE,
                             'bg-transmaes-red': entry.status === Statusses.STOP }">
              </div>
            </div>
            <p class="ml-6 mt-3 text-3xl">{{entry.datetime.format('HH:mm')}}</p>
            <p v-if="entry.status === Statusses.START" class="ml-6 mt-5 text-xl text-transmaes-green capitalize">
              {{$t('home_item_start')}}
            </p>
            <p v-if="entry.status === Statusses.PAUSE" class="ml-6 mt-5 text-xl text-transmaes-yellow capitalize">
              {{$t('home_action_pause')}}
            </p>
            <p v-if="entry.status === Statusses.STOP" class="ml-6 mt-5 text-xl text-transmaes-red capitalize">
              {{$t('home_button_stop')}}
            </p>
          </div>
          <div class="flex flex-row">
            <div class="h-16 w-16 bg-gray-200 flex justify-center items-center"
                 :class="{ 'rounded-full': !activeRide || Object.keys(activeRide).length === 0,
                           'rounded-b-full': activeRide && activeRide.entries && activeRide.entries.length > 0}">
            </div>
            <p class="text-gray-600 ml-6 mt-3 text-3xl">{{currentTime}}</p>
            <div>
              <v-button @click="emptyObject ? createRide(): createNewEntry(Statusses.START) "
                        class="ml-6 bg-transmaes-green"
                        v-if="lastEntry && lastEntry.status === Statusses.PAUSE || !lastEntry"
                        :label="$t('home_item_start')"/>
              <v-button @click="createNewEntry(Statusses.PAUSE)" class="ml-6 bg-transmaes-yellow"
                        v-if="lastEntry &&lastEntry.status === Statusses.START"
                        :label="$t('home_action_pause')"/>
              <v-button @click="createNewEntry(Statusses.STOP)" class="ml-6 bg-transmaes-red"
                        v-if="lastEntry && lastEntry.status === Statusses.START"
                        :label="$t('home_action_stop')"/>
            </div>
          </div>
        </main>
        <footer class="flex bg-white border-t border-solid border-gray-500">
          <div class="flex flex-row px-16 py-6">
            <div class="w-2/4">
              <p class="text-transmaes-green text-xl capitalize">
                {{$t('home_stat_driven')}}
              </p>
              <p class="text-3xl">{{moment("1900-01-01 00:00:00")
                .add(activeRide.timeDriven, 'seconds').format("H")
                + `h` +  moment("1900-01-01 00:00:00")
                  .add(activeRide.timeDriven, 'seconds').format("mm")}}'</p>
            </div>
            <div class="w-2/4">
              <p class="text-transmaes-yellow text-xl capitalize">
                {{$t('home_stat_paused')}}
              </p>
              <p class="text-3xl">{{moment("1900-01-01 00:00:00")
                .add(activeRide.timePaused, 'seconds').format("H")
                + `h` +  moment("1900-01-01 00:00:00")
                  .add(activeRide.timePaused, 'seconds').format("mm")}}'</p>
            </div>
          </div>
        </footer>
      </div>
      <div class="col-span-4 bg-gray-200 border-l border-solid border-gray-500">
        <div class="flex justify-center h-20 items-center border-b border-solid border-gray-500">
          <p class="text-xl text-gray-600 capitalize">
            {{$t('history_title')}}
          </p>
        </div>
        <div class="pt-3 pb-3">
          <ul class="overflow-y-auto overflow-x-hidden h-screen77 list-none">
            <li v-for="ride in rides" :key="ride.id">
              <v-card class="ml-6 mr-6 mt-3 mb-6">
                <div class="flex flex-row border-b border-solid border-gray-500 pb-5">
                  <div class="w-2/4">
                    <p class="text-gray-600">{{ride.startedAt.format('DD MMMM')}}</p>
                    <p class="text-3xl">{{ride.startedAt.format('HH:mm')}}</p>
                  </div>
                  <div class="w-2/4" v-if="ride.endedAt">
                    <p class="text-gray-600">{{ride.endedAt.format('DD MMMM')}}</p>
                    <p class="text-3xl">{{ride.endedAt.format('HH:mm')}}</p>
                  </div>
                </div>
                <div class="flex flex-row pt-5">
                  <div class="w-2/4">
                    <p class="text-transmaes-green capitalize">
                      {{$t('home_stat_driven')}}
                    </p>
                    <p class="text-2xl">{{moment("1900-01-01 00:00:00")
                      .add(ride.timeDriven, 'seconds').format("H")
                      + `h` +  moment("1900-01-01 00:00:00")
                        .add(ride.timeDriven, 'seconds').format("mm")}}'</p>
                  </div>
                  <div class="w-2/4">
                    <p class="text-transmaes-yellow capitalize">
                      {{$t('home_stat_paused')}}
                    </p>
                    <p class="text-2xl">{{moment("1900-01-01 00:00:00")
                      .add(ride.timePaused, 'seconds').format("H")
                      + `h` +  moment("1900-01-01 00:00:00")
                        .add(ride.timePaused, 'seconds').format("mm")}}'</p>
                  </div>
                </div>
              </v-card>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import moment from 'moment';
  import VCard from '../components/common/VCard';
  import VButton from '../components/common/VButton';
  import Statusses from '../constants/Statusses';

  export default {
    name: 'TheOverview',
    components: {
      VButton,
      VCard,
    },
    data() {
      return {
        moment,
        Statusses,
        loading: false,
        error: null,
        currentTime: null,
      };
    },
    computed: {
      user() {
        return this.$store.getters['auth/user'];
      },
      greeting() {
        return this.$i18n.t('home_greeting_title_web', [this.user.fullname]);
      },
      activeRide() {
        return this.$store.state.ride.item;
      },
      emptyObject() {
        return Object.keys(this.activeRide).length === 0;
      },
      rides() {
        return this.$store.state.ride.list.filter((item) => item.startedAt && item.endedAt);
      },
      lastEntry() {
        if (this.$store.state.ride.item.entries) {
          return this.$store.state.ride.item.entries.slice(-1).pop();
        }

        return null;
      },
    },
    created() {
      this.loadRide();
      this.loadRides();
      this.currentTime = moment().format('HH:mm');

      setInterval(() => {
        this.currentTime = moment().format('HH:mm');
      }, 60 * 1000);
    },
    methods: {
      ...mapActions('ride', {
        getRide: 'getRide',
        create: 'create',
        getRides: 'getRides',
        createEntry: 'createEntry',
      }),
      loadRide() {
        this.loading = true;

        this.getRide().then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      loadRides() {
        this.getRides().then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      createRide() {
        this.create().then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      createNewEntry(status) {
        this.createEntry({
          driveId: this.activeRide.id,
          status,
        }).then(() => {
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      },
      logout() {
        this.$router.push({ name: 'login' });
      },
    },
  };

</script>
